var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 12L9.99955 5.00004M19.9995 20H6.99955M9.93681 19.0628L18.6054 10.3941C19.7935 9.2061 20.3875 8.61207 20.6101 7.92709C20.8058 7.32456 20.8058 6.67551 20.6101 6.07298C20.3875 5.388 19.7935 4.79397 18.6054 3.60592L18.3937 3.39415C17.2056 2.2061 16.6116 1.61207 15.9266 1.38951C15.3241 1.19373 14.675 1.19373 14.0725 1.38951C13.3875 1.61207 12.7935 2.2061 11.6054 3.39415L3.39366 11.6059C2.20561 12.794 1.61158 13.388 1.38902 14.073C1.19324 14.6755 1.19324 15.3246 1.38902 15.9271C1.61158 16.6121 2.20561 17.2061 3.39366 18.3941L4.06229 19.0628C4.40819 19.4087 4.58114 19.5816 4.78298 19.7053C4.96192 19.815 5.15701 19.8958 5.36108 19.9448C5.59126 20 5.83585 20 6.32503 20H7.67406C8.16324 20 8.40784 20 8.63801 19.9448C8.84208 19.8958 9.03717 19.815 9.21612 19.7053C9.41795 19.5816 9.5909 19.4087 9.93681 19.0628Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.b4904a051a98306472da4325ef1e1756.svg";
export { ForwardRef as ReactComponent };